'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Star } from 'lucide-react';
import { Card, CardHeader, Divider, CardBody } from "@heroui/react";

type RatingProps = {
    id: number;
    uen: string;
    companyName: string;
    url: string;
};

const Rating = ({ id, uen, companyName, url }: RatingProps) => {
    const [rating, setRating] = useState<number>(-1);

    const router = useRouter();
    const handleRatingChange = (newRating: number) => {
        setRating(newRating);
    };

    const handleRatingSubmit = (rating: number) => {
        router.push(`/companies/${uen}/${url}/rate?rating=${rating}`);
    };

    return (
        <Card radius="md" className="md:col-span-2">
            <CardHeader className="bs flex flex-row gap-2">
                <h2 className="font-semibold">Review This Business</h2>
            </CardHeader>
            <Divider />
            <CardBody className="items-center justify-center bg-white">
                <div className="flex flex-col items-center justify-center p-2 gap-2">
                    <p className="text-sm">Recently transacted with {companyName}? </p>
                    <p className="text-sm">How would you rate your overall satisfaction?</p>
                    <div
                        className="flex flex-row items-center justify-evenly rounded-md"
                        onMouseLeave={() => handleRatingChange(-1)}
                    >
                        {[1, 2, 3, 4, 5].map((star) => (
                            <div
                                key={star}
                                className={`p-2 transition-all duration-300 ease-in-out ${star <= rating ? 'bg-primary' : 'bg-secondary-200'}`}
                            >
                                <Star
                                    className={`h-8 w-8 cursor-pointer ${
                                        star <= rating ? 'fill-white text-white' : 'text-zinc-500'
                                    }`}
                                    onClick={() => handleRatingSubmit(star)}
                                    onMouseEnter={() => handleRatingChange(star)}
                                />
                            </div>
                        ))}
                    </div>
                    {/* {companyName == 'WISTECH CONSULTING PTE. LTD.' && (
                        <div className="flex flex-col items-center">
                            <div className="flex flex-row items-center justify-center gap-1">
                                {[...Array(5)].map((_, index) => (
                                    <Star key={index} className="h-4 w-4 text-yellow-500 fill-yellow-500" />
                                ))}
                            </div>
                            <p className="text-sm">1 review</p>
                        </div>
                    )} */}
                    <p className="text-sm">
                        Be a part of the community and help others make informed decisions by sharing your experience. Your feedback not only helps the business improve
                        but also assists other customers in choosing the best services and products available.
                    </p>
                </div>
            </CardBody>
        </Card>
    );
};

export default Rating;
